<template>
  <div v-if="rendered">
    <ClientePerfil
      v-if="verPerfil"
      :dados-cliente-selecionado="dadosClienteSelecionado"
      :restaurantes="[]"
      @voltar="verPerfil = false"
    />
    <div v-if="!verPerfil">
      <base-header class="pb-6">
        <b-row align-v="center" class="py-4">
          <b-col cols="12">
            <h6 class="h2 d-inline-block mb-0">
              {{ enviarIndividual ? "Enviar Mensagem" : "Criar Campanha" }}
            </h6>
          </b-col>
        </b-row>
      </base-header>

      <b-container fluid class="mt--6 content">
        <b-row>
          <b-col xl="7">
            <!-- Stepper -->
            <div class="cmp-stepper" v-if="!enviarIndividual">
              <div
                v-for="(s, i) in stepsVisiveis"
                :key="i"
                class="cmp-step"
                :class="{
                  'is-done': stepAtual > s.num,
                  'is-active': stepAtual === s.num,
                  'is-pending': stepAtual < s.num,
                }"
                @click="stepAtual > s.num ? irParaStep(s.num) : null"
              >
                <div class="cmp-step-dot">
                  <i v-if="stepAtual > s.num" class="ni ni-check-bold"></i>
                  <span v-else>{{ i + 1 }}</span>
                </div>
                <span class="cmp-step-label">{{ s.label }}</span>
              </div>
            </div>

            <!-- Passo 1 — Modo -->
            <campanha-passo1
              :visivel="stepAtual === 1 && !enviarIndividual"
              :is-teste.sync="isTeste"
              :total-passos="stepsVisiveis.length"
              @avancar="stepAtual = 2"
            />

            <!-- Passo 2 — Audiência -->
            <campanha-passo2
              :visivel="stepAtual === 2 && !enviarIndividual"
              :is-teste.sync="isTeste"
              :total-passos="stepsVisiveis.length"
              :titulo.sync="tituloCampanha"
              :enviar-para-todos.sync="enviarParaTodos"
              :filtro-selecionado.sync="filtroSelecionado"
              :filtros="filtros_utilizador"
              :num-clientes="numeroClientesEnviar"
              :destinatarios-teste.sync="selects.multiple"
              :opcoes-contactos="selectOptions"
              :valido="passo2Valido"
              @mudar-filtro="mudarFiltro"
              @avancar="stepAtual = 3"
              @recuar="stepAtual = 1"
            />

            <!-- Passo 3 — Canal + Mensagem -->
            <campanha-passo3
              :visivel="stepAtual === 3"
              :enviar-individual="enviarIndividual"
              :total-passos="stepsVisiveis.length"
              :canal="canalSelecionado"
              :loading-templates="loadingTemplates"
              :template-selecionado.sync="templateSelecionado"
              :templates-whatsapp="templatesWhatsapp"
              :template-tem-imagem="templateTemImagem"
              :url-imagem.sync="urlImagemWhatsApp"
              :file-selecionado.sync="fileSelecionado"
              :template-push.sync="templatePushSelecionado"
              :templates-push="templatesPush"
              :mensagem.sync="mensagemPush"
              :valido="passo3Valido"
              @selecionar-canal="selecionarCanal"
              @mudar-template-whatsapp="mudarMensagemWhatsapp"
              @aplicar-template-push="aplicarTemplatePush"
              @guardar-template="guardarTemplate"
              @avancar="stepAtual = 4"
              @recuar="stepAtual = 2"
            />

            <!-- Passo 4 — Envio -->
            <campanha-passo4
              :visivel="stepAtual === 4"
              :enviar-individual="enviarIndividual"
              :is-teste="isTeste"
              :total-passos="stepsVisiveis.length"
              :titulo="tituloCampanha"
              :canal="canalSelecionado"
              :template="templateSelecionado"
              :enviar-para-todos="enviarParaTodos"
              :num-clientes="numeroClientesEnviar"
              :data-evento.sync="dataEvento"
              :agendar="agendar"
              :data-agendada.sync="dataAgendada"
              :hora-agendada.sync="horaAgendada"
              @toggle-agendar="agendar = !agendar"
              @enviar="enviarMensagem"
              @agendar="agendarMensagem"
              @recuar="stepAtual = 3"
            />
          </b-col>

          <!-- Painel lateral de resultados -->
          <b-col xl="5">
            <div v-if="resultados.length > 0" class="aud-panel">
              <div class="aud-panel-head">
                <p class="aud-panel-eyebrow">Audiência</p>
                <h3 class="aud-panel-title">
                  <span class="aud-count">{{
                    resultadosComTermos.length
                  }}</span>
                  clientes vão receber
                </h3>
                <p
                  v-if="resultados.length !== resultadosComTermos.length"
                  class="aud-termos-aviso"
                >
                  {{ resultados.length - resultadosComTermos.length }} sem
                  termos aceites — não receberão
                </p>
              </div>
              <div class="aud-panel-list">
                <div
                  v-for="(c, i) in resultadosComTermos.slice(0, 100)"
                  :key="i"
                  class="aud-item"
                  @click="abrirPerfil(c.qr_code)"
                >
                  <div class="aud-avatar">
                    {{ (c.nome || "?")[0].toUpperCase() }}
                  </div>
                  <div class="aud-info">
                    <span class="aud-nome">{{ c.nome }}</span>
                    <span class="aud-code">{{ c.qr_code }}</span>
                  </div>
                  <div class="aud-arrow">›</div>
                </div>
              </div>
              <div v-if="resultadosComTermos.length > 100" class="aud-more">
                + {{ resultadosComTermos.length - 100 }} clientes adicionais
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
  <LoadingOverlay v-else />
</template>

<script>
  import LoadingOverlay from "@/components/Loading/LoadingOverlay";
  import { Table, TableColumn, Select, Option } from "element-ui";
  import DropzoneFileUpload from "@/components/Inputs/DropzoneFileUpload";
  import { campanhasService, filtrosService, cartaoService } from "@/services";
  import CampanhaPasso1 from "./Passos/CampanhaPasso1.vue";
  import CampanhaPasso2 from "./Passos/CampanhaPasso2.vue";
  import CampanhaPasso3 from "./Passos/CampanhaPasso3.vue";
  import CampanhaPasso4 from "./Passos/CampanhaPasso4.vue";
  import ClientePerfil from "../Clientes/ClientePerfil.vue";
  export default {
    components: {
      LoadingOverlay,
      [Select.name]: Select,
      [Option.name]: Option,
      DropzoneFileUpload,
      CampanhaPasso1,
      CampanhaPasso2,
      CampanhaPasso3,
      CampanhaPasso4,
      ClientePerfil,
    },
    data() {
      return {
        rendered: false,
        stepAtual: 1,
        loadingTemplates: false,
        isTeste: false,
        enviarParaTodos: false,
        enviarIndividual: false,
        selectOptions: [], // 🔹 opções para o select de teste
        selects: {
          multiple: [], // 🔹 qr_codes escolhidos para teste
        },
        fileSelecionado: null,
        templatesWhatsapp: [],
        templatesWhatsappOriginal: [],
        savingTemplate: false,
        templatePushSelecionado: null,
        resultados: [],
        agendar: false,
        filtros: {
          consumoRestaurantes: [
            { id: Date.now(), operador: "E", vezes: 1, restaurante: null },
          ],
          segmentacao: null,
          restaurante: [],
          genero: [],
          idade: [],
          estado: [],
          data_ultima_visita: "0",
          data_sem_visitar: "0",
          data_inscricao: "0",
          data_inscricao_de: null,
          data_inscricao_ate: null,
          total_visitas_de: null,
          total_visitas_ate: null,
          total_gasto_min: null,
          total_gasto_max: null,
          ticket_medio_min: null,
          ticket_medio_max: null,
          produtos: [{ id: Date.now() + 1, nome: "", vezes: null }],
          total_mensagens_min: null,
          total_mensagens_max: null,
          periodo_mensagens: [],
          envios: [],
          contas_individuais: {
            tipo: null,
            min: null,
            max: null,
          },
        },

        dataEvento: { inicio: null, fim: null },
        dataAgendada: null,
        horaAgendada: null,
        filtroSelecionado: "",
        canalSelecionado: "",
        templateSelecionado: null,
        mensagemPush: "",
        tituloCampanha: "",
        urlImagemWhatsApp: "",
        whatsappImagem: null,
        todosClientes: [],
        clientesFiltrados: [],
        filtros_utilizador: [],
        templatesPush: [],
        numeroClientesEnviar: 0,
        restaurantesUsadosFiltro: [],
        verPerfil: false,
        dadosClienteSelecionado: null,
      };
    },
    computed: {
      stepsVisiveis() {
        return [
          { num: 1, label: "Modo" },
          { num: 2, label: this.isTeste ? "Destinatários" : "Audiência" },
          { num: 3, label: "Mensagem" },
          { num: 4, label: "Envio" },
        ];
      },
      passo2Valido() {
        if (this.isTeste) {
          return this.selects.multiple && this.selects.multiple.length > 0;
        }
        if (!this.tituloCampanha || !this.tituloCampanha.trim()) return false;
        if (!this.enviarParaTodos && !this.filtroSelecionado) return false;
        return true;
      },
      passo3Valido() {
        if (!this.canalSelecionado) return false;
        if (this.canalSelecionado === "whatsapp")
          return !!this.templateSelecionado;
        if (this.canalSelecionado === "push")
          return this.mensagemPush && this.mensagemPush.trim().length >= 30;
        return false;
      },
      // Clientes com termos aceites (para mostrar no painel e contar corretamente)
      resultadosComTermos() {
        return this.resultados.filter(
          (c) => c.termos_1 == 1 || c.termos_1 === true,
        );
      },
      campanhaValida() {
        return (
          this.filtroSelecionado &&
          this.dataEvento &&
          this.dataEvento.inicio &&
          this.numeroClientesEnviar > 0 &&
          this.canalSelecionado &&
          ((this.canalSelecionado === "whatsapp" && this.templateSelecionado) ||
            (this.canalSelecionado === "push" &&
              this.mensagemPush &&
              this.mensagemPush.trim().length >= 30)) &&
          this.tituloCampanha &&
          this.tituloCampanha.trim().length > 0
        );
      },
      templateSelecionadoObj() {
        return (
          this.templatesWhatsapp.find(
            (t) => t.label === this.templateSelecionado,
          ) || null
        );
      },
      templateTemImagem() {
        if (!this.templateSelecionadoObj) return false;
        return this.templateSelecionadoObj.components.some(
          (c) => c.type === "HEADER" && c.format === "IMAGE",
        );
      },
    },
    methods: {
      async carregarSegmento(id) {
        if (!this.filtros_utilizador || this.filtros_utilizador.length === 0) {
          console.warn("⚠️ filtros_utilizador ainda não carregado");
          return;
        }

        const filtro = this.filtros_utilizador.find(
          (f) => String(f.id) === String(id),
        );

        if (filtro) {
          this.filtroSelecionado = filtro.value;
          this.mudarFiltro(filtro.id);
        }
      },
      async guardarTemplate() {
        let mensagem = (this.mensagemPush || "").trim();
        let titulo = (this.tituloCampanha || "").trim();

        if (!mensagem || mensagem.length < 30) {
          this.$notify({
            type: "warning",
            title: "Mensagem obrigatória",
            message:
              "Por favor insira uma mensagem válida para o Push Notification (mínimo 30 caracteres).",
          });
          return;
        }
        if (!titulo) {
          this.$notify({
            type: "warning",
            title: "Título obrigatório",
            message:
              "Por favor insira um título de campanha válido para o template.",
          });
          return;
        }

        this.savingTemplate = true;
        try {
          const data = await campanhasService.guardarTemplatePush(
            titulo,
            mensagem,
          );

          if (data.success) {
            // Normaliza o objeto devolvido
            const template = data.template || { id: data.id, titulo, mensagem };
            const option = this.toTemplateOption(template);

            // Atualiza a lista local (update ou insert)
            this.upsertTemplateLocal(option, { preferId: !!template.id });

            // Notificação consoante ação
            const action = data.action || "created"; // fallback
            this.$notify({
              type: "success",
              title:
                action === "updated"
                  ? "Template atualizado"
                  : "Template guardado",
              message:
                action === "updated"
                  ? "O template existente foi atualizado com a nova mensagem."
                  : "O template foi criado com sucesso.",
            });
          } else {
            this.$notify({
              type: "danger",
              title: "Erro",
              message: data.error || "Não foi possível guardar o template.",
            });
          }
        } catch (err) {
          console.error("❌ Erro a guardar template:", err);
          this.$notify({
            type: "danger",
            title: "Erro",
            message:
              err?.response?.data?.error ||
              "Ocorreu um erro ao guardar o template. Tente novamente.",
          });
        } finally {
          this.savingTemplate = false;
        }
      },
      async uploadImagem(file) {
        if (!file) return;

        file = file[0];
        // validar tamanho
        if (file.size > 2 * 1024 * 1024) {
          this.$notify({
            type: "danger",
            title: "Erro",
            message: "A imagem não pode exceder 2MB.",
          });
          return;
        }

        const formData = new FormData();
        formData.append("imagem", file);

        try {
          const resp = await campanhasService.uploadImagem(formData);

          if (resp.success) {
            this.urlImagemWhatsApp = "https://abitue.yourcode.pt" + resp.url;
          }
        } catch (err) {
          console.error("❌ Erro upload:", err);
          this.$notify({
            type: "danger",
            title: "Erro",
            message: "Erro ao fazer upload da imagem.",
          });
        }
      },
      async aplicarTemplatePush() {
        var mensagem = this.templatesPush.find(
          (x) => x.value == this.templatePushSelecionado,
        ).mensagem;
        this.mensagemPush = mensagem;
      },
      async enviarParaApi(payload) {
        this.rendered = false;

        try {
          const payloadComTeste = {
            ...payload,
            teste: this.isTeste,
            destinatarios: this.isTeste
              ? this.selects.multiple
              : payload.destinatarios,
          };
          const data = await campanhasService.criar(payloadComTeste);
          // SUCESSO
          this.$notify({
            type: "success",
            title: "Sucesso!",
            message: data.message || "Campanha criada com sucesso!",
          });

          // Reset dos campos
          this.tituloCampanha = "";
          this.filtroSelecionado = null;
          this.canalSelecionado = null;
          this.templateSelecionado = null;
          this.urlImagemWhatsApp = "";
          this.mensagemPush = "";
          this.dataEvento = { inicio: null, fim: null };
          this.dataAgendada = null;
          this.horaAgendada = null;
          this.templatePushSelecionado = null;
          this.resultados = [];
          this.numeroClientesEnviar = 0;
          this.agendar = false;
          this.selects.multiple = [];
          this.isTeste = false;
          this.enviarParaTodos = false;
          this.stepAtual = 1;
        } catch (err) {
          console.error("Erro ao enviar campanha:", err);

          let mensagemErro = "Ocorreu um erro ao criar a campanha.";

          if (err.response?.data) {
            const res = err.response.data;
            const d = res.detalhes || {};

            // ERRO DE LIMITE DE PUSH
            if (
              res.error?.includes("Limite de notificações push") ||
              res.error?.includes("atingido")
            ) {
              const limite = d.limite_mensal ?? "indefinido";
              const usados = d.usados_ultimos_30_dias ?? "vários";
              const dataProxima = d.proxima_data_formatada ?? "em breve";

              mensagemErro = `
        ⚠ Limite de Push Atingido<br>

        O teu plano permite até ${limite} notificações push por mês.
        Já enviaste ${usados} nos últimos 30 dias.

        Próxima data disponível: ${dataProxima}
      `;
            }
            // Plano não permite push
            else if (
              res.error?.includes("não permite enviar notificações push")
            ) {
              mensagemErro = `
        Plano sem suporte a Push

        O teu plano atual não permite enviar notificações push.
        Faz upgrade para um plano superior para enviar.
      `;
            }
            // Créditos insuficientes
            else if (res.error?.includes("Créditos push insuficientes")) {
              const restantes = d.restantes ?? 0;
              const pedidos = d.solicitadas ?? "?";

              mensagemErro = `
        Não tens push suficientes

        Tens apenas ${restantes} push disponíveis, mas estás a tentar enviar ${pedidos}.
        Reduz o número de destinatários ou aguarda o reset do limite.
      `;
            }
            // Qualquer outro erro
            else if (res.error) {
              mensagemErro = `${res.error}`;
            }
          }

          this.$notify({
            type: "danger",
            title: "Erro",
            message: mensagemErro,
            duration: 8000,
          });
        } finally {
          this.rendered = true;
        }
      },
      mudarMensagemWhatsapp(templateId) {
        const template = this.templatesWhatsapp.find(
          (t) => t.label === templateId,
        );
        if (!template) return;

        // extrai os textos dos componentes
        const texto = template.components
          .filter((c) => c.text)
          .map((c) => c.text.trim())
          .join("\n\n");

        this.mensagemPush = texto;
      },
      construirPayload(agendado = false) {
        let dataEnvio, horaEnvio;

        if (agendado && this.dataAgendada && this.horaAgendada) {
          dataEnvio = this.dataAgendada; // yyyy-mm-dd
          horaEnvio = this.horaAgendada; // hh:mm:ss
        } else {
          const agora = new Date();
          dataEnvio = agora.toISOString().split("T")[0];
          horaEnvio = agora.toTimeString().split(" ")[0];
        }

        // Garante que tens o array de restaurantes filtrados
        const usados =
          this.restaurantesUsadosFiltro &&
          Array.isArray(this.restaurantesUsadosFiltro)
            ? this.restaurantesUsadosFiltro
            : this.extrairRestaurantes(this.filtroSelecionado?.json);

        var destinatarios = null;
        var destinatarios = null;
        if (this.enviarIndividual) {
          destinatarios = JSON.parse(localStorage.getItem("Abitue_enviarPara"));
        } else if (this.enviarParaTodos) {
          destinatarios = this.todosClientes.map((c) => c.qr_code);
        } else {
          destinatarios = this.resultados.map((c) => c.qr_code);
        }
        const payload = {
          tituloCampanha: this.tituloCampanha,
          filtroNome: this.filtroSelecionado, // ou o label, conforme quiseres
          canal: this.canalSelecionado,
          dia_evento: this.dataEvento,
          mensagem: "",
          urlImagem: null,
          agendado: agendado,
          destinatarios: destinatarios,
          restaurantes_filtrados: usados && usados.length ? usados : null, // 🔹 AQUI
          dataEnvio,
          horaEnvio,
          todaBd: this.enviarParaTodos,
        };

        if (this.canalSelecionado === "whatsapp") {
          payload.mensagem = this.templateSelecionado;
          payload.templateWhatsapp = this.templateSelecionado;
          if (this.templateTemImagem)
            payload.urlImagem = this.urlImagemWhatsApp;
        } else if (this.canalSelecionado === "push") {
          payload.mensagem = this.mensagemPush;
        }

        return payload;
      },
      validarCampanha() {
        // 1. Segmento selecionado e pelo menos 1 cliente
        if (
          !this.isTeste &&
          !this.enviarIndividual &&
          !this.enviarParaTodos &&
          (!this.filtroSelecionado || this.numeroClientesEnviar <= 0)
        ) {
          this.$notify({
            type: "danger",
            title: "Segmento em falta",
            message:
              "É necessário selecionar um segmento com pelo menos 1 cliente.",
          });
          return false;
        }

        // 2. Canal escolhido
        if (!this.canalSelecionado) {
          this.$notify({
            type: "danger",
            title: "Canal em falta",
            message:
              "Por favor escolha o canal de envio (WhatsApp ou Push Notification).",
          });
          return false;
        }

        // 3. WhatsApp: validar template e imagem
        if (this.canalSelecionado === "whatsapp") {
          if (!this.templateSelecionado) {
            this.$notify({
              type: "danger",
              title: "Template em falta",
              message: "Selecione um template de WhatsApp antes de prosseguir.",
            });
            return false;
          }
          if (this.templateTemImagem && !this.urlImagemWhatsApp) {
            this.$notify({
              type: "danger",
              title: "Imagem em falta",
              message:
                "Este template requer uma imagem. Insira o URL da imagem antes de enviar.",
            });
            return false;
          }
        }

        // 4. Push: validar mensagem
        if (this.canalSelecionado === "push") {
          if (!this.mensagemPush || this.mensagemPush.trim().length < 30) {
            this.$notify({
              type: "danger",
              title: "Mensagem inválida",
              message: "A mensagem de Push deve ter pelo menos 30 caracteres.",
            });
            return false;
          }
        }

        // 5. Dia do Evento (só se não for teste)
        if (!this.isTeste && !(this.dataEvento && this.dataEvento.inicio)) {
          this.$notify({
            type: "danger",
            title: "Data em falta",
            message: "Defina pelo menos a data de início do evento.",
          });
          return false;
        }

        // 6. Título da campanha (só se não for teste)
        if (
          !this.isTeste &&
          (!this.tituloCampanha || this.tituloCampanha.trim().length === 0)
        ) {
          this.$notify({
            type: "danger",
            title: "Título em falta",
            message: "Defina um título para a campanha.",
          });
          return false;
        }

        return true;
      },
      async enviarMensagem() {
        if (!this.validarCampanha()) return;

        const payload = this.construirPayload(false);

        await this.enviarParaApi(payload);
      },
      async agendarMensagem() {
        if (!this.validarCampanha()) return;

        const payload = this.construirPayload(true);
        await this.enviarParaApi(payload);
      },
      toTemplateOption(t) {
        return {
          label: t.titulo,
          value: t.id,
          mensagem: t.mensagem,
        };
      },
      upsertTemplateLocal(option, { preferId = true } = {}) {
        // Atualiza ou insere no this.templatesPush evitando duplicados
        if (!Array.isArray(this.templatesPush)) this.templatesPush = [];

        // 1) Tenta por ID
        let idx =
          preferId && option.value
            ? this.templatesPush.findIndex((x) => x.value === option.value)
            : -1;

        // 2) Se não encontrou por ID, tenta por título/label
        if (idx === -1 && option.label) {
          idx = this.templatesPush.findIndex((x) => x.label === option.label);
        }

        if (idx >= 0) {
          // update (mantém a posição)
          this.templatesPush.splice(idx, 1, option);
        } else {
          // insert no topo
          this.templatesPush.unshift(option);
        }
      },
      irParaStep(num) {
        this.stepAtual = num;
      },
      async selecionarCanal(canal) {
        this.canalSelecionado = canal;
        this.templateSelecionado = null;
        this.templatePushSelecionado = null;
        this.mensagemPush = "";
        await this.verificarCanal(canal);
      },
      async verificarCanal(canal) {
        canal = canal || this.canalSelecionado;
        this.mensagemPush = "";

        if (canal === "whatsapp") {
          // Só chama se ainda não tiver templates guardados
          if (!this.templatesWhatsapp || this.templatesWhatsapp.length === 0) {
            this.loadingTemplates = true;
            try {
              const resp = await campanhasService.checkWhatsappConfig();

              if (!resp.success) {
                this.$notify({
                  type: "danger",
                  title: "Erro",
                  message: resp.message,
                });
                this.canalSelecionado = null;
                return;
              }

              if (resp.templates?.length > 0) {
                const temp = resp.templates;
                this.templatesWhatsapp = temp
                  .filter((t) => t.status === "APPROVED")
                  .map((t) => ({
                    label: t.name,
                    value: t.id,
                    components: t.components,
                  }))
                  .sort((a, b) =>
                    a.label.localeCompare(b.label, "pt", {
                      sensitivity: "base",
                    }),
                  );
              } else {
                this.$notify({
                  type: "danger",
                  title: "Erro",
                  message: "Não existem templates aprovados.",
                });
              }
            } catch (err) {
              console.error("❌ Erro WhatsApp:", err);
              this.$notify({
                type: "danger",
                title: "Erro",
                message: "Erro ao verificar configuração do WhatsApp.",
              });
            } finally {
              this.loadingTemplates = false;
            }
          }
        } else if (canal === "push") {
          // Só chama se ainda não tiver templates guardados
          if (!this.templatesPush || this.templatesPush.length === 0) {
            this.loadingTemplates = true;
            try {
              const resp = await campanhasService.getTemplatesPush();
              if (resp.success) {
                this.templatesPush = resp.templates.map((t) => ({
                  label: t.titulo,
                  value: t.id,
                  mensagem: t.mensagem,
                }));
              }
            } catch (err) {
              console.error("❌ Erro Push:", err);
              this.$notify({
                type: "danger",
                title: "Erro",
                message: "Erro ao carregar templates de Push.",
              });
            } finally {
              this.loadingTemplates = false;
            }
          }
        }
      },

      calcularIdade(dataNascimento) {
        const hoje = new Date();
        const nascimento = new Date(dataNascimento);

        let idade = hoje.getFullYear() - nascimento.getFullYear();
        const mesAtual = hoje.getMonth();
        const mesNascimento = nascimento.getMonth();

        // Se ainda não fez anos este ano, subtrai 1
        if (
          mesAtual < mesNascimento ||
          (mesAtual === mesNascimento && hoje.getDate() < nascimento.getDate())
        ) {
          idade--;
        }

        return idade;
      },
      faixaEtaria(idade) {
        if (idade == null) return "–";
        if (idade < 18) return "<18"; // opcional
        if (idade <= 24) return "18–24";
        if (idade <= 34) return "25–34";
        if (idade <= 44) return "35–44";
        if (idade <= 54) return "45–54";
        return "55+";
      },
      async carregarFiltros() {
        try {
          const lista = await filtrosService.listar();
          for (let i = 0; i < lista.length; i++) {
            this.filtros_utilizador.push({
              id: lista[i].id,
              label: lista[i].nome,
              value: lista[i].nome,
              json: JSON.parse(lista[i].filtro_json),
            });
          }
        } catch (err) {
          if (err.response && err.response.status === 403) {
            localStorage.removeItem("tokenAbitue");
            this.$router.push("/login");
          } else {
            console.error("Erro ao carregar filtros:", err);
          }
        }
      },
      async carregarCampanhaParaClone(campaignId) {
        try {
          const data = await campanhasService.clonarCampanha(campaignId);

          if (data.success && data.campanha) {
            const c = data.campanha;
            // Preenche os campos necessários

            this.canalSelecionado = "push";
            await this.verificarCanal();
            this.mensagemPush = c.mensagem || "";
          }
        } catch (err) {
          console.error("❌ Erro ao carregar campanha clonada:", err);
          this.$notify({
            type: "danger",
            title: "Erro",
            message: "Não foi possível carregar a campanha a clonar.",
          });
        }
      },
      async carregarTemplate(templateId) {
        try {
          const data = await campanhasService.clonarTemplate(templateId);

          if (data.success && data.template) {
            const t = data.template;
            // Preenche os campos necessários
            this.templateTitulo = t.titulo || "";
            this.canalSelecionado = "push";
            await this.verificarCanal();
            this.mensagemPush = t.mensagem || "";
            this.templatePushSelecionado = t.id || null;
          }
        } catch (err) {
          console.error("❌ Erro ao carregar template clonado:", err);
          this.$notify({
            type: "danger",
            title: "Erro",
            message: "Não foi possível carregar o template a clonar.",
          });
        }
      },
      async inicio() {
        this.rendered = false;
        try {
          const res = await cartaoService.getLightAll();
          this.todosClientes = res.data;
          // this.todosClientes = enriquecidos;
          // // 🔹 Criar opções para ambiente de teste
          this.selectOptions = this.todosClientes.map((c) => ({
            label: `${c.nome} - ${c.qr_code}`, // aparece no dropdown
            value: c.qr_code, // valor real enviado
          }));

          await this.carregarFiltros();

          const campaignId = this.$route?.query?.campaign_cloned_id;
          const templateId = this.$route?.query?.template_id;
          const segmentoId = this.$route?.query?.segmento_id;
          const enviarIndividual = this.$route?.query?.enviarIndividual;

          if (campaignId) {
            await this.carregarCampanhaParaClone(campaignId);
          }
          if (templateId) {
            await this.carregarTemplate(templateId);
          }
          if (segmentoId) {
            await this.carregarSegmento(segmentoId);
          }
          if (enviarIndividual) {
            this.enviarIndividual = true;
            this.stepAtual = 3;
          }
        } catch (err) {
          if (err.response && err.response.status === 403) {
            localStorage.removeItem("tokenAbitue");
            this.$router.push("/login");
          }
        }
      },

      async aplicarFiltros(filtroId) {
        this.rendered = false;
        const response = await cartaoService.getLight({
          page: 1,
          perPage: -1,
          filtroId,
        });
        this.resultados = response.data;
        this.resultadosFiltrados = response.total;
        this.numeroClientesEnviar = response.total;
        setTimeout(() => {
          this.rendered = true;
        }, 1500);
      },

      extrairRestaurantes(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const lista = Array.isArray(obj?.consumoRestaurantes)
          ? obj.consumoRestaurantes
          : [];

        return [
          ...new Set(
            lista
              .filter(
                (r) =>
                  r && Number(r.vezes) > 0 && typeof r.restaurante === "string",
              )
              .map((r) => r.restaurante.trim())
              .filter(Boolean),
          ),
        ];
      },
      normalizarDataServidor(str) {
        if (!str) return null;

        // Mantém apenas AAAA-MM-DD (ignora Z / timezone)
        const iso = String(str).split("T")[0];

        const [y, m, d] = iso.split("-").map(Number);

        const dt = new Date(y, m - 1, d);
        dt.setHours(0, 0, 0, 0);

        return dt;
      },
      async abrirPerfil(qrCode) {
        try {
          const data = await cartaoService.getPerfil(qrCode);
          this.dadosClienteSelecionado = data;
          this.verPerfil = true;
        } catch (err) {
          this.$notify({
            type: "danger",
            title: "Erro",
            message: "Não foi possível carregar o perfil.",
          });
        }
      },
      async mudarFiltro(idSelecionado) {
        const filtroSelecionado = this.filtros_utilizador.find(
          (f) => f.id === idSelecionado,
        );

        if (!filtroSelecionado || !filtroSelecionado.json) return;

        try {
          const filtro = filtroSelecionado.json;
          this.filtros = { ...this.filtros, ...filtro };
          this.aplicarFiltros(filtroSelecionado.id);
        } catch (error) {
          console.error("Erro ao aplicar filtro guardado:", error);
        }
        this.restaurantesUsadosFiltro = this.extrairRestaurantes(
          filtroSelecionado.json,
        );
      },
    },
    watch: {
      fileSelecionado(novoFicheiro) {
        if (novoFicheiro) {
          this.uploadImagem(novoFicheiro);
        }
      },
    },
    async mounted() {
      await this.inicio();

      this.rendered = true;
    },
  };
</script>
<style>
  /* ─── Stepper ─────────────────────────────────────── */
  .cmp-stepper {
    display: flex;
    align-items: center;
    gap: 0;
    margin-bottom: 28px;
  }
  .cmp-step {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    cursor: default;
    position: relative;
  }
  .cmp-step::after {
    content: "";
    flex: 1;
    height: 2px;
    background: #e2e8f0;
    margin: 0 8px;
    border-radius: 1px;
    transition: background 0.3s ease;
  }
  .cmp-step:last-child::after {
    display: none;
  }
  .cmp-step.is-done::after {
    background: #ff825d;
  }

  .cmp-step-dot {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 2px solid #e2e8f0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    color: #adb5bd;
    transition: all 0.25s ease;
    flex-shrink: 0;
  }
  .cmp-step.is-active .cmp-step-dot {
    border-color: #ff825d;
    background: #ff825d;
    color: #fff;
    box-shadow: 0 0 0 4px rgba(255, 130, 93, 0.15);
  }
  .cmp-step.is-done .cmp-step-dot {
    border-color: #ff825d;
    background: #ff825d;
    color: #fff;
    cursor: pointer;
  }
  .cmp-step-label {
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.3px;
    color: #adb5bd;
    white-space: nowrap;
  }
  .cmp-step.is-active .cmp-step-label {
    color: #373737;
  }
  .cmp-step.is-done .cmp-step-label {
    color: #ff825d;
  }

  /* ─── Card container ──────────────────────────────── */
  .cmp-card {
    background: #fff;
    border: 1px solid #edf0f5;
    border-radius: 16px;
    padding: 28px 32px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  }

  .cmp-card-eyebrow {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #ff825d;
    margin-bottom: 6px;
  }
  .cmp-card-title {
    font-size: 1.25rem;
    font-weight: 700;
    color: #373737;
    margin-bottom: 6px;
  }
  .cmp-card-sub {
    font-size: 0.85rem;
    color: #8898aa;
    margin-bottom: 20px;
  }

  /* ─── Labels ──────────────────────────────────────── */
  .cmp-label {
    display: block;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #8898aa;
    margin-bottom: 8px;
  }

  /* ─── Choice cards ────────────────────────────────── */
  .cmp-choice-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 4px;
  }
  .cmp-choice {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 16px;
    border: 1.5px solid #e2e8f0;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.15s ease;
    background: #fff;
  }
  .cmp-choice:hover {
    border-color: #ff825d;
    background: rgba(255, 130, 93, 0.03);
  }
  .cmp-choice.is-selected {
    border-color: #ff825d;
    background: rgba(255, 130, 93, 0.05);
  }
  .cmp-choice-icon {
    font-size: 20px;
    flex-shrink: 0;
    line-height: 1;
  }
  .cmp-choice-name {
    font-weight: 600;
    font-size: 0.875rem;
    color: #373737;
  }
  .cmp-choice-desc {
    font-size: 0.775rem;
    color: #8898aa;
    margin-top: 1px;
  }
  .cmp-choice-check {
    margin-left: auto;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1.5px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.15s ease;
    color: transparent;
    font-size: 10px;
  }
  .cmp-choice.is-selected .cmp-choice-check {
    background: #ff825d;
    border-color: #ff825d;
    color: #fff;
  }

  /* ─── Sub-fields ──────────────────────────────────── */
  .cmp-sub-field {
    background: #f8fafc;
    border: 1px solid #edf0f5;
    border-radius: 10px;
    padding: 16px;
    margin-top: 8px;
  }

  /* ─── Badge de contagem ───────────────────────────── */
  .cmp-count-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(255, 130, 93, 0.08);
    border: 1px solid rgba(255, 130, 93, 0.2);
    border-radius: 20px;
    padding: 5px 12px;
    font-size: 0.8rem;
    font-weight: 600;
    color: #ff825d;
    margin-top: 10px;
  }

  /* ─── Image hint ──────────────────────────────────── */
  .cmp-image-hint {
    background: #fff7f5;
    border: 1px solid rgba(255, 130, 93, 0.2);
    border-radius: 8px;
    padding: 12px 14px;
    font-size: 0.825rem;
    color: #6e6e6e;
  }

  /* ─── Textarea ────────────────────────────────────── */
  .cmp-textarea {
    border-radius: 10px !important;
    border-color: #e2e8f0 !important;
    font-size: 0.875rem !important;
    resize: vertical;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }
  .cmp-textarea:focus {
    border-color: #ff825d !important;
    box-shadow: 0 0 0 3px rgba(255, 130, 93, 0.1) !important;
  }
  .cmp-textarea:disabled {
    background: #f8fafc !important;
    color: #8898aa !important;
  }

  /* ─── Ações ───────────────────────────────────────── */
  .cmp-actions {
    display: flex;
    gap: 10px;
    margin-top: 24px;
    flex-wrap: wrap;
  }

  /* ─── Bloco agendar ───────────────────────────────── */
  .cmp-agendar-block {
    background: #f8fafc;
    border: 1.5px dashed #ced4da;
    border-radius: 12px;
    padding: 20px;
    animation: cmpFadeIn 0.2s ease;
  }

  /* ─── Transição entre passos ──────────────────────── */
  .cmp-slide-enter-active,
  .cmp-slide-leave-active {
    transition: all 0.22s ease;
  }
  .cmp-slide-enter {
    opacity: 0;
    transform: translateX(16px);
  }
  .cmp-slide-leave-to {
    opacity: 0;
    transform: translateX(-16px);
  }

  @keyframes cmpFadeIn {
    from {
      opacity: 0;
      transform: translateY(-6px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* ─── Herança do f-box original ───────────────────── */
  .f-box {
    display: flex;
    gap: 15px;
  }

  /* ─── Painel lateral de audiência ────────────────── */
  .aud-panel {
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    position: sticky;
    top: 24px;
  }
  .aud-panel-head {
    padding: 20px 22px 14px;
    border-bottom: 1px solid #f5f2ef;
  }
  .aud-panel-eyebrow {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #ff825d;
    margin-bottom: 4px;
  }
  .aud-panel-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: #1a1210;
    margin: 0;
  }
  .aud-count {
    color: #ff825d;
  }
  .aud-panel-list {
    max-height: 420px;
    overflow-y: auto;
    padding: 8px 0;
  }
  .aud-panel-list::-webkit-scrollbar {
    width: 4px;
  }
  .aud-panel-list::-webkit-scrollbar-thumb {
    background: #e8e4e0;
    border-radius: 2px;
  }
  .aud-item {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 9px 22px;
    transition: background 0.1s;
  }
  .aud-item:hover {
    background: #faf8f6;
  }
  .aud-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #f0ece8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    color: #7a736e;
    flex-shrink: 0;
  }
  .aud-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
  .aud-nome {
    font-size: 13.5px;
    font-weight: 600;
    color: #1a1210;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .aud-code {
    font-size: 11.5px;
    color: #b0a8a0;
  }
  .aud-more {
    padding: 12px 22px;
    font-size: 12.5px;
    font-weight: 600;
    color: #b0a8a0;
    border-top: 1px solid #f5f2ef;
    text-align: center;
  }

  .aud-termos-aviso {
    font-size: 11.5px;
    color: #e8872a;
    margin: 4px 0 0;
    font-weight: 500;
  }
  .aud-item {
    cursor: pointer;
  }
  .aud-arrow {
    margin-left: auto;
    font-size: 16px;
    color: #d0c8c0;
    flex-shrink: 0;
    transition: color 0.1s;
  }
  .aud-item:hover .aud-arrow {
    color: #ff825d;
  }
</style>
